'use client';

import {
  MenuContent,
  MenuItem,
  MenuRoot,
  MenuTrigger,
} from '@/components/ui/menu';
import { Box, Text } from '@chakra-ui/react';
import { useRouter } from '@/i18n/navigation';
import { getWhereToGoHref } from '@/_lib/brand-href';
import { FEATURED_BRANDS } from '@/_utils/Constants';
import { ChevronDown } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import mikaService from '@/_service/mika.service';
import { useMemo } from 'react';

interface BrandSelectMobileProps {
  brandName: string;
}

export default function BrandSelectMobile({ brandName }: BrandSelectMobileProps) {
  const router = useRouter();

  const handleSelectBrand = (shipperId: string, branchSlugOrId: string) => {
    router.push(getWhereToGoHref(shipperId, branchSlugOrId));
  };

  const { data } = useQuery({
    queryKey: ['branches-list'],
    queryFn: () =>
      mikaService.getBranchList({
        search: '',
        page: 1,
        limit: 10,
        is_open: true,
      }),
  });

  const branches = useMemo(
    () =>
      data?.data?.branches?.filter(
        // Hide Yoko Pizza
        (branch) => branch.shipper_id !== FEATURED_BRANDS.yokopizza,
      ) ?? [],
    [data],
  );

  return (
    <MenuRoot
      positioning={{ placement: 'bottom-start', offset: { mainAxis: 8 } }}
    >
      <MenuTrigger asChild>
        <Box
          w='fit'
          as='button'
          cursor='pointer'
          display='flex'
          alignItems='center'
          gap={1}
          _hover={{ opacity: 0.9 }}
        >
          <Text fontSize='xl' fontWeight={600}>
            {brandName}
          </Text>
          <ChevronDown size={20} strokeWidth={2} />
        </Box>
      </MenuTrigger>
      <MenuContent
        minW='200px'
        py={2}
        rounded={12}
        bg='background.card'
        border='1px solid'
        borderColor='gray.200'
      >
        {branches.map((branch) => (
          <MenuItem
            key={branch.id}
            value={branch.id}
            cursor='pointer'
            onClick={() =>
              handleSelectBrand(branch.shipper_id, branch.slug || branch.id)
            }
            py={2}
            px={2}
            display='flex'
            alignItems='center'
            rounded={6}
            gap={2}
          >
            <Text fontSize='sm' fontWeight={600} color='text'>
              {branch.name}
            </Text>
          </MenuItem>
        ))}
      </MenuContent>
    </MenuRoot>
  );
}
